'use client';
import React, { useState } from 'react';
import { SHAME_ENTRIES, SHAME_CATEGORIES } from './ShameData';

export default function ShameGrid() {
  const [activeCategory, setActiveCategory] = useState('All');

  const filtered = SHAME_ENTRIES.filter(
    (e) => activeCategory === 'All' || e.category === activeCategory
  );

  return (
    <div>
      {/* Category Filters */}
      <div className="flex flex-wrap gap-2 mb-6">
        {SHAME_CATEGORIES.map((cat) => (
          <button
            key={cat}
            onClick={() => setActiveCategory(cat)}
            className="px-3 py-1.5 rounded-full text-xs font-semibold transition-all duration-200 hover:scale-105"
            style={{
              background: activeCategory === cat ? 'rgba(239,68,68,0.2)' : 'rgba(255,255,255,0.04)',
              color: activeCategory === cat ? '#ef4444' : 'rgba(255,255,255,0.4)',
              border: `1px solid ${activeCategory === cat ? 'rgba(239,68,68,0.4)' : 'rgba(255,255,255,0.08)'}`,
            }}
          >
            {cat}
          </button>
        ))}
      </div>

      {/* Empty State */}
      {filtered.length === 0 && (
        <div className="flex flex-col items-center justify-center py-16 gap-3 text-center">
          <span className="text-5xl">😇</span>
          <p className="text-lg font-bold" style={{ color: 'rgba(255,255,255,0.5)' }}>
            No offenders here yet
          </p>
          <p className="text-sm max-w-xs" style={{ color: 'rgba(255,255,255,0.25)' }}>
            The Hall of Shame is empty. Real entries will appear here once added.
          </p>
        </div>
      )}

      {/* Grid */}
      {filtered.length > 0 && (
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
          {filtered.map((entry) => (
            <div
              key={entry.id}
              className="rounded-2xl p-5 transition-all duration-300 hover:scale-[1.02] cursor-pointer"
              style={{
                background: 'rgba(20,5,5,0.8)',
                border: '1px solid rgba(239,68,68,0.12)',
              }}
              onMouseEnter={(e) => {
                (e.currentTarget as HTMLDivElement).style.boxShadow = '0 0 30px rgba(239,68,68,0.1)';
                (e.currentTarget as HTMLDivElement).style.borderColor = 'rgba(239,68,68,0.25)';
              }}
              onMouseLeave={(e) => {
                (e.currentTarget as HTMLDivElement).style.boxShadow = 'none';
                (e.currentTarget as HTMLDivElement).style.borderColor = 'rgba(239,68,68,0.12)';
              }}
            >
              <div className="flex items-start justify-between mb-4">
                <div
                  className="w-11 h-11 rounded-xl flex items-center justify-center text-2xl"
                  style={{ background: 'rgba(239,68,68,0.1)', border: '1px solid rgba(239,68,68,0.2)' }}
                >
                  {entry.categoryIcon}
                </div>
                <span
                  className="text-xs font-bold px-2.5 py-1 rounded-full"
                  style={{ background: 'rgba(239,68,68,0.08)', color: '#ef4444' }}
                >
                  {entry.period}
                </span>
              </div>
              <h3 className="text-sm font-extrabold mb-1" style={{ color: 'rgba(255,255,255,0.9)' }}>{entry.category}</h3>
              <p className="text-xs leading-relaxed mb-4" style={{ color: 'rgba(255,255,255,0.4)' }}>{entry.description}</p>
              <div
                className="flex items-center justify-between p-3 rounded-xl mb-4"
                style={{ background: 'rgba(239,68,68,0.06)', border: '1px solid rgba(239,68,68,0.1)' }}
              >
                <span className="text-xs" style={{ color: 'rgba(255,255,255,0.35)' }}>{entry.statLabel}</span>
                <span className="text-base font-extrabold" style={{ color: '#ef4444' }}>{entry.stat}</span>
              </div>
              <div className="flex items-center gap-2.5">
                <div
                  className="w-8 h-8 rounded-full flex items-center justify-center text-xs font-bold flex-shrink-0"
                  style={{ background: `${entry.avatarColor}22`, color: entry.avatarColor }}
                >
                  {entry.initials}
                </div>
                <div className="flex-1 min-w-0">
                  <p className="text-xs font-bold truncate" style={{ color: 'rgba(255,255,255,0.8)' }}>{entry.displayName}</p>
                  <p className="text-xs truncate" style={{ color: 'rgba(255,255,255,0.3)' }}>{entry.username}</p>
                </div>
                <div
                  className="text-xs font-semibold px-2 py-1 rounded-full flex-shrink-0"
                  style={{ background: 'rgba(239,68,68,0.08)', color: '#f97316' }}
                >
                  🏷️ {entry.badge}
                </div>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
